
// import React, { useEffect } from 'react';
// import './Committee.css';
// import { useLanguage } from '../context/LanguageContext';
// import Icon from '../components/Icon';

// /* Scroll-reveal hook — same as About page */
// const useScrollReveal = (selector, options = {}) => {
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((e) => {
//           if (e.isIntersecting) e.target.classList.add('in-view');
//         });
//       },
//       { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options }
//     );
//     document.querySelectorAll(selector).forEach((el) => observer.observe(el));
//     return () => observer.disconnect();
//   }, [selector]);
// };

// const Committee = () => {
//   const { t } = useLanguage();

//   const committeeMembers = t('committee.members', { returnObjects: true }) || [];

//   useScrollReveal('.trust-info-card');
//   useScrollReveal('.committee-table-container');
//   useScrollReveal('.udyam-card');
//   useScrollReveal('.objectives-list li');

//   return (
//     <div className="committee-page">

//       {/* ── CINEMATIC HERO ── same feeling as About page ── */}
//       <div className="committee-hero">
//         <div className="committee-hero-bg" />
//         <div className="committee-hero-overlay" />
//         <div className="committee-hero-rays" aria-hidden="true">
//           {[...Array(5)].map((_, i) => (
//             <span key={i} className={`committee-ray committee-ray-${i + 1}`} />
//           ))}
//         </div>

//         <div className="committee-hero-content">
//           <span className="committee-hero-pill">{t('nav.committee')}</span>
//           <h1 className="committee-hero-title">{t('committee.pageTitle')}</h1>
//           <div className="committee-hero-divider">
//             <span className="chd-line" />
//             <span className="chd-diamond">◆</span>
//             <span className="chd-line" />
//           </div>
//         </div>

//         <div className="committee-hero-bottom-line" />
//       </div>

//       {/* ── PAGE BODY ── */}
//       <div className="container">

//         {/* Trust Intro + Table */}
//         <section className="committee-section">
//           <div className="trust-intro in-view">
//             <div className="subtitle-frame">
//               <span className="line-dec"></span>
//               <span className="trust-label">{t('committee.pageSubtitle')}</span>
//               <span className="line-dec"></span>
//             </div>
//           </div>

//           <p className="committee-intro-text">{t('committee.intro')}</p>

//           <div className="committee-table-container">
//             <table className="committee-table">
//               <thead>
//                 <tr>
//                   <th>{t('committee.table.name')}</th>
//                   <th>{t('committee.table.role')}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {committeeMembers.map((member) => (
//                   <tr key={member.id}>
//                     <td>{member.name}</td>
//                     <td>{member.role}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </section>

//         {/* ── Trust Information Card ── with scroll reveal */}
//         <section className="trust-info-section">
//           <div className="trust-info-card">
//             <div className="trust-info-header">
//               <div className="trust-emblem">
//                 <Icon name="temple" />
//               </div>
//               <div className="trust-header-text">
//                 <h2 className="trust-info-title">{t('committee.trust.sectionTitle')}</h2>
//                 <div className="trust-name-block">
//                   <p className="trust-marathi-name">
//                     {t('committee.trust.trustNameMarathi')}
//                   </p>
//                   <p className="trust-english-name">{t('committee.trust.trustName')}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="trust-divider" />

//             <div className="trust-details-grid">
//               <div className="trust-detail-item highlight">
//                 <Icon name="certificate" />
//                 <span>{t('committee.trust.registerNumber')}</span>
//               </div>
//               <div className="trust-detail-item">
//                 <Icon name="info" />
//                 <span>{t('committee.trust.trustType')}</span>
//               </div>
//               <div className="trust-detail-item">
//                 <Icon name="calendar" />
//                 <span>{t('committee.trust.established')}</span>
//               </div>
//               <div className="trust-detail-item">
//                 <Icon name="location" />
//                 <span>{t('committee.trust.jurisdiction')}</span>
//               </div>
//             </div>

//             <div className="trust-divider" />

//             {/* UDYAM Registration */}
//             <div className="udyam-badge-container">
//               <div className="udyam-card">
//                 <div className="udyam-header">
//                   <Icon name="certificate" className="text-orange-500" />
//                   <h3 className="udyam-title">{t('committee.trust.udyamTitle')}</h3>
//                 </div>
//                 <div className="udyam-number-block">
//                   <span className="udyam-item-label">
//                     {t('committee.trust.udyamRegNumLabel')}
//                   </span>
//                   <div className="udyam-number">
//                     {t('committee.trust.udyamRegistrationNumber')}
//                   </div>
//                 </div>
//                 <div className="udyam-grid">
//                   <div className="udyam-item">
//                     <span className="udyam-item-label">
//                       {t('committee.trust.udyamRegDateLabel')}
//                     </span>
//                     <span className="udyam-item-value">
//                       {t('committee.trust.udyamRegistrationDate')}
//                     </span>
//                   </div>
//                   <div className="udyam-item">
//                     <span className="udyam-item-label">
//                       {t('committee.trust.udyamEnterpriseTypeLabel')}
//                     </span>
//                     <span className="udyam-item-value">
//                       {t('committee.trust.udyamEnterpriseType')}
//                     </span>
//                   </div>
//                   <div className="udyam-item">
//                     <span className="udyam-item-label">
//                       {t('committee.trust.udyamIssuedByLabel')}
//                     </span>
//                     <span className="udyam-item-value">
//                       {t('committee.trust.udyamIssuedBy')}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="trust-divider" />

//             {/* Objectives */}
//             <div className="trust-objectives">
//               <h3 className="objectives-title">
//                 <Icon name="flag" />{' '}
//                 {t('committee.trust.sectionTitle') === 'About the Trust'
//                   ? 'Objectives'
//                   : 'उद्दिष्टे'}
//               </h3>
//               <ul className="objectives-list">
//                 <li>
//                   <Icon name="check" />
//                   {t('committee.trust.objective1')}
//                 </li>
//                 <li>
//                   <Icon name="check" />
//                   {t('committee.trust.objective2')}
//                 </li>
//                 <li>
//                   <Icon name="check" />
//                   {t('committee.trust.objective3')}
//                 </li>
//                 <li>
//                   <Icon name="check" />
//                   {t('committee.trust.objective4')}
//                 </li>
//               </ul>
//             </div>

//             <div className="trust-footer-note">
//               <Icon name="info" />
//               <p>{t('committee.trust.footerNote')}</p>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default Committee;









import React, { useEffect } from 'react';
import './Committee.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';

const useScrollReveal = (selector, options = {}) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px', ...options });
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [selector]);
};

const Committee = () => {
  const { t } = useLanguage();
  const committeeMembers = t('committee.members', { returnObjects: true }) || [];

  useScrollReveal('.committee-scroll-item');
  useScrollReveal('.trust-scroll-wrapper');
  useScrollReveal('.udyam-scroll-wrapper');
  useScrollReveal('.objectives-scroll-wrapper');

  return (
    <div className="committee-page">

      {/* ── CINEMATIC HERO ── */}
      <div className="committee-hero">
        <div className="committee-hero-bg" />
        <div className="committee-hero-overlay" />
        <div className="committee-hero-rays" aria-hidden="true">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={`committee-ray committee-ray-${i + 1}`} />
          ))}
        </div>
        <div className="committee-hero-content">
          <span className="committee-hero-pill-pill">{t('nav.committee')}</span>
          <h1 className="committee-hero-title">{t('committee.pageTitle')}</h1>
          <div className="committee-hero-divider">
            <span className="chd-line" />
            <span className="chd-diamond">◆</span>
            <span className="chd-line" />
          </div>
        </div>
        <div className="committee-hero-bottom-line" />
      </div>

      <div className="container">

        {/* 1. INTRO — parchment scroll */}
        <section className="committee-intro-section">
          <div className="committee-intro-parchment">
            <div className="committee-intro-content">
              <h2 className="committee-intro-title">{t('committee.pageTitle')}</h2>
              <div className="parchment-divider" />
              <div className="subtitle-frame">
                <span className="line-dec" />
                <span className="trust-label">{t('committee.pageSubtitle')}</span>
                <span className="line-dec" />
              </div>
              <p className="committee-intro-text">{t('committee.intro')}</p>
            </div>
          </div>
        </section>

        {/* 2. TABLE — parchment scroll */}
        <section className="committee-table-section">
          <h2 className="section-title">{t('committee.pageTitle')}</h2>
          <div className="section-header-divider">
            <span className="dot" /><span className="line" /><span className="dot" />
          </div>
          <div className="committee-scroll-item">
            <div className="committee-scroll-content">
              <div className="scroll-inner-header">
                <span className="scroll-ornament">❧</span>
                <h3 className="scroll-inner-title">{t('committee.table.name')} / {t('committee.table.role')}</h3>
                <span className="scroll-ornament">❧</span>
              </div>
              <div className="parchment-divider" />
              <div className="committee-table-wrap">
                <table className="committee-table">
                  <thead>
                    <tr>
                      <th>{t('committee.table.name')}</th>
                      <th>{t('committee.table.mobile')}</th>
                      <th>{t('committee.table.role')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {committeeMembers.map((member) => (
                      <tr style={{ fontWeight: '700' }} key={member.id}>
                        <td>{member.name}</td>
                          <td>{member.mobile}</td>
                        <td>{member.role}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>

        {/* 3. TRUST INFO — parchment scroll */}
        <section className="trust-info-section">
          <div className="trust-scroll-wrapper">
            <div className="trust-scroll-content">
              <div className="scroll-inner-header">
                <span className="scroll-ornament">❧</span>
                <h3 className="scroll-inner-title">{t('committee.trust.sectionTitle')}</h3>
                <span className="scroll-ornament">❧</span>
              </div>
              <div className="parchment-divider" />
              <div className="trust-name-block">
                <div className="trust-emblem"><Icon name="temple" /></div>
                <p className="trust-marathi-name">{t('committee.trust.trustNameMarathi')}</p>
                <p className="trust-english-name">{t('committee.trust.trustName')}</p>
              </div>
              <div className="parchment-thin-divider" />
              <div className="trust-details-grid">
               <div className="trust-detail-item highlight">
  <Icon name="certificate" />
  <span >
    {t('committee.trust.registerNumber')}
  </span>
</div>

<div className="trust-detail-item">
  <Icon name="info" />
  <span >
    {t('committee.trust.trustType')}
  </span>
</div>

<div className="trust-detail-item">
  <Icon name="calendar" />
  <span >
    {t('committee.trust.established')}
  </span>
</div>

<div className="trust-detail-item">
  <Icon name="location" />
  <span >
    {t('committee.trust.jurisdiction')}
  </span>
</div>
              </div>
            </div>
          </div>
        </section>

        {/* 4. UDYAM — parchment scroll */}
        <section className="udyam-section">
          <div className="udyam-scroll-wrapper">
            <div className="udyam-scroll-content">
              <div className="scroll-inner-header">
                <span className="scroll-ornament">❧</span>
                <h3 className="scroll-inner-title">
                  <Icon name="certificate" /> {t('committee.trust.udyamTitle')}
                </h3>
                <span className="scroll-ornament">❧</span>
              </div>
              <div className="parchment-divider" />
              <div className="udyam-number-block">
                <span className="udyam-item-label">{t('committee.trust.udyamRegNumLabel')}</span>
                <div className="udyam-number">{t('committee.trust.udyamRegistrationNumber')}</div>
              </div>
              <div className="udyam-grid">
                <div className="udyam-item">
                  <span className="udyam-item-label">{t('committee.trust.udyamRegDateLabel')}</span>
                  <span className="udyam-item-value">{t('committee.trust.udyamRegistrationDate')}</span>
                </div>
                <div className="udyam-item">
                  <span className="udyam-item-label">{t('committee.trust.udyamEnterpriseTypeLabel')}</span>
                  <span className="udyam-item-value">{t('committee.trust.udyamEnterpriseType')}</span>
                </div>
                <div className="udyam-item">
                  <span className="udyam-item-label">{t('committee.trust.udyamIssuedByLabel')}</span>
                  <span className="udyam-item-value">{t('committee.trust.udyamIssuedBy')}</span>
                </div>
              </div>

<p className="committee-intro-text" style={{marginTop:"20px"}}>{t('committee.80gCertificate')}</p>


            </div>
          </div>
        </section>

        {/* 5. OBJECTIVES — parchment scroll */}
        <section className="objectives-section">
          <div className="objectives-scroll-wrapper">
            <div className="objectives-scroll-content">
              <div className="scroll-inner-header">
                <span className="scroll-ornament">❧</span>
                <h3 className="scroll-inner-title">
                  <Icon name="flag" />{' '}
                  {t('committee.trust.sectionTitle') === 'About the Trust' ? 'Objectives' : 'उद्दिष्टे'}
                </h3>
                <span className="scroll-ornament">❧</span>
              </div>
              <div className="parchment-divider" />
              <ul>
                <p>{t('committee.trust.objective1')}</p>
                <p>{t('committee.trust.objective2')}</p>
                <p>{t('committee.trust.objective3')}</p>
                <p>{t('committee.trust.objective4')}</p>
                <p>{t('committee.trust.footerNote')}</p>
              </ul>
             
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Committee;